module.exports = __webpack_public_path__ + "ba9f35aafb977e1554eb23599ec17906.pdf";